import { MedicineTabs, DataSourceType } from '../common/enums';
import { GenericBasicModel } from './genericBasicModel';
import { string } from 'prop-types';

export class MedicineBasicModel {
  public medicineId: number;
  public brandName: string;
  public additionalTitle: string;
  public authorisationStatus: number;
  public dataSourceTypeId: DataSourceType;
  public medicineDataURL: string;
  public medicineTabs: Array<MedicineTabs>;
  public generics: Array<GenericBasicModel>;
  public medicineNumber: string;
  public emaProductNumber: string;
}